/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-max-depth */
import { Card, Group, Button, Skeleton, Modal, Text } from '@mantine/core';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ButtonLink from '../../components/elements/ButtonLink';
import SelectBox from '../../components/fields/SelectBox';
import { AppContext } from '../../contexts';
import { deleteFaqV2ById, fetchCategoryV2, fetchSubPangkalanFaq, reorderFaqList } from './actions';
import FormDetail from './FormDetail';
import styles from './styles.scoped.css';
import { useDebounce } from '../../utils/hooks';
import TextInput from '../../components/fields/Text';
import { thousand } from '../../utils/format';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import SortableCard from './SortableCard';

export default function SubPangkalan() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useContext(AppContext);
  const [category, setCategory] = useState('all');
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [item, setItem] = useState({});
  const [search, setSearch] = useState('');
  const [searchMode, setSearchMode] = useState(false);
  const debouncedSearch = useDebounce(search, 500);
  const inputRef = useRef(null);
  const lastSearchRef = useRef('');
  const searchLoadingRef = useRef(false);

  const {
    dataCategoriesV2,
    dataSubPangkalanFaq: dataFaq,
    isLoadingSubPangkalanFaq,
    isLoadingDeleteFaq,
  } = useSelector((s) => s.faq);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    setBreadcrumbs(['Pengaturan FAQ']);
    dispatch(fetchCategoryV2());
    dispatch(fetchSubPangkalanFaq({ category }));
  }, []);

  useEffect(() => {
    if(!isLoadingDeleteFaq && category){
      dispatch(fetchSubPangkalanFaq({ category }));
      dispatch(fetchCategoryV2());
    }
  },[isLoadingDeleteFaq, category]);

  useEffect(() => {
    searchLoadingRef.current = isLoadingSubPangkalanFaq;
  }, [isLoadingSubPangkalanFaq]);

  useEffect(() => {
    if (debouncedSearch !== lastSearchRef.current) {
      lastSearchRef.current = debouncedSearch;

      if (debouncedSearch) {
        setSearchMode(true);
        dispatch(fetchSubPangkalanFaq({ category, search: debouncedSearch }));
      } else {
        setSearchMode(false);
        dispatch(fetchSubPangkalanFaq({ category }));
      }
    }
  }, [debouncedSearch]);

  const showDetail = (item) => {
    setOpenModal(true);
    setItem(item);
  };

  const rediectUpdate = (item) =>
    navigate(`/faq/editSubpangkalan?faqId=${item.faqId}`);

  const onDelete = (id) => {
    setOpenConfirmModal(false);
    dispatch(deleteFaqV2ById(id));
  };

  const handleDragEnd = (event, categoryKey) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const items = dataFaq.find(section => section[categoryKey])[categoryKey];
    const oldIndex = items.findIndex(item => item.faqId === active.id);
    const newIndex = items.findIndex(item => item.faqId === over.id);
    const reorderedItems = arrayMove(items, oldIndex, newIndex);
    const faqIds = reorderedItems.map(item => item.faqId);
    dispatch(reorderFaqList(categoryKey, faqIds));
  };

  const isSearchActive = searchMode && search.trim() !== '';

  if (isLoadingSubPangkalanFaq && !dataFaq) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
        {[1, 2].map((item) => (
          <React.Fragment key={item}>
            <div className={styles.topContainer}>
              <div className={styles.categoryContainer}>
                <Skeleton height={24} width={100} />
              </div>
            </div>
            <Card mb={40} padding="md" sx={{ border: '1px solid #D9DEE4', borderRadius: '5px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <Skeleton height={24} mb={12} width="60%" />
                  <Skeleton height={16} mb={8} width="100%" />
                  <Skeleton height={16} width="80%" />
                </div>
                <Group ml={16} spacing="md">
                  <Skeleton height={40} width={40} />
                  <Skeleton height={40} width={40} />
                  <Skeleton height={40} width={40} />
                </Group>
              </div>
            </Card>
          </React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <>
      <div className={styles.filterContainer}>
        <div className={styles.filter}>
          <label className={styles.label}>Kategori</label>
          <SelectBox
            className={styles.filterComponent}
            data={[
              { value: 'all', label: 'Semua Kategori' },
              ...(dataCategoriesV2 || [])
            ]}
            eventName="filter_faq_by_category"
            input={{ value: category ? category : true }}
            label={''}
            onChangeSelect={(e) => setCategory(e)}
            searchable={false}
            valueForm={category} />
        </div>
        <ButtonLink className={styles.updatePriceBtn} to={'/faq/set?type=subpangkalan'} type="primary" >
            Buat FAQ
        </ButtonLink>
      </div>
      <section className={styles['notification-wrapper']}>
        <div className={styles['action-wrapper']}>
          <div className={styles.action}>
            <span>Menampilkan&nbsp;
              {thousand(dataFaq?.reduce((acc, section) => {
                const key = Object.keys(section)[0];
                return acc + section[key].length;
              }, 0) || 0)} data</span>
          </div>
          <div className={styles.filters}>
            <TextInput
              className={styles['search-bar']}
              hideLabel
              inputProps={{
                ref: inputRef,
                placeholder: 'Cari FAQ...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => setSearch(e.target.value),
              }}
            />
          </div>
        </div>
      </section>
      <div className={styles.listCategories}>
        {dataFaq?.map((data, idx) => {
          let key = Object.keys(data)[0];
          return (
            <div key={idx + key}>
              <div className={styles.topContainer}>
                <div className={styles.categoryContainer}>
                  <label className={styles.categoryTitle}>{key}</label>
                </div>
              </div>
              <DndContext
                collisionDetection={closestCenter}
                disabled={isSearchActive}
                modifiers={[restrictToVerticalAxis]}
                onDragEnd={(event) => handleDragEnd(event, key)}
                sensors={sensors}
              >
                <SortableContext
                  items={data[key].map(item => item.faqId)}
                  strategy={verticalListSortingStrategy}
                  style={{ overflow: 'visible' }}
                >
                  {data[key].map((item, index) => (
                    <SortableCard
                      id={item.faqId}
                      isSearchActive={isSearchActive}
                      item={{ ...item, orderNumber: index + 1 }}
                      key={item.faqId}
                      onClickDelete={() => {
                        setItem(item);
                        setOpenConfirmModal(true);
                      }}
                      onClickDetail={() => showDetail(item)}
                      onClickUpdate={() => rediectUpdate(item)}
                    />
                  ))}
                </SortableContext>
              </DndContext>
            </div>
          );
        })}
      </div>

      <Modal
        centered={true}
        onClose={() => setOpenModal(false)}
        opened={openModal}
        overflow="inside"
        size="xl"
        title={'Detail FAQ Subpangkalan'}
      >
        <FormDetail fromSubPangkalan item={item} onCloseModal={() => setOpenModal(false)} type={'detail'}/>
      </Modal>

      <Modal
        centered={true}
        opened={openConfirmModal} withCloseButton>
        <div className={styles.row}>
          <Text className={styles.textTitle}>Apakah kamu yakin akan menghapus FAQ ini?</Text>
        </div>
        <div className={styles['form-action']}>
          <Button
            onClick={()=> setOpenConfirmModal(false)}
            variant="outline"
          >
              Batal
          </Button>
          <Button onClick={() => onDelete(item.faqId)}
            sx={() => ({
              width: 40,
              backgroundColor: 'var(--primary-color)',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                backgroundColor: 'var(--primary-color)',
                opacity: 0.8,
              }
            })}
            type="submit">
              Hapus
          </Button>
        </div>
      </Modal>
    </>
  );
}
